import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

function MenuCategoryCard({ title, image, id, onClose }: { title: string; image: string | string[]; id: number, onClose: () => void }) {
  const lang = useLanguage();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/${lang}/category/${id}`);
    onClose();
  }

  return (
    <div
      onClick={handleClick}
      className="w-[177px] h-[90px] rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 flex items-end justify-between cursor-pointer overflow-hidden"
    >
        <p className="text-[11px] font-semibold mb-3 pl-[15px] text-gray-800">{title}</p>
       <img
       loading="eager"
            src={Array.isArray(image) ? image[0] : image}
            alt={title}
            className="w-[86px] h-full object-contain"
          />
    </div>
  )
}

export default MenuCategoryCard